// 🌌 BGG — el fondo que sigue al ratón.
//
// Escribe DOS números en :root, --mx y --my, normalizados a [-1, 1] respecto
// al centro del viewport. Quien los usa es 🖌️STY.pcss: las tres manchas del
// fondo (.BGG::before, .BGG::after, .BGG_blob) los multiplican por unos pocos
// px en su `translate`, cada una con su factor y su signo, y con transiciones
// de 1,2 a 2 s. El retardo y el suavizado son del CSS: aquí no hay ni
// interpolación ni bucle de animación.
//
// Reglas, y todas tienen motivo:
//   · El listener se ata SIEMPRE; quien decide es `e.pointerType !== 'mouse'`,
//     que sale en seco. La pregunta que importa es QUIÉN MUEVE, no qué puede
//     el dispositivo: en táctil no llega ningún pointermove de ratón, así que
//     el efecto se apaga solo sin preguntarle nada al navegador, y en un
//     portátil híbrido funciona con el ratón y NO con el dedo — que es lo que
//     se quería decir y lo que `(hover: hover) and (pointer: fine)` no decía.
//     De paso, esa consulta era FALSA en un Chromium headless (no hay
//     dispositivo apuntador), así que el paralaje no existía en ningún arnés y
//     no se podía medir en ninguno; por el pointerType sí se puede.
//   · Con «reducir movimiento» no se ata: el CSS ya apaga las derivas, y esto
//     es la otra mitad del mismo acuerdo.
//   · El listener SÓLO guarda coordenadas. Cero lecturas de layout en el
//     move, cero escrituras de estilo: un pointermove puede llegar a 1000 Hz
//     con un ratón gaming y no puede costar un reflow por evento.
//   · Un rAF pendiente como MUCHO, nunca dos en vuelo: el guard es el propio
//     handle. Así el DOM se toca una vez por frame pintado, no una por evento.
//
// API: initBGG() una vez en el boot. Idempotente.

let px = 0
let py = 0
let frame = 0
let atado = false

export function initBGG() {
  if (atado) return

  const quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches
  if (quieto) return

  atado = true
  window.addEventListener('pointermove', onMove, { passive: true })
}

function onMove(e) {
  if (e.pointerType !== 'mouse') return
  px = e.clientX
  py = e.clientY
  if (frame) return
  frame = requestAnimationFrame(write)
}

function write() {
  frame = 0
  const root = document.documentElement
  // innerWidth/innerHeight y no un getBoundingClientRect: el viewport no
  // depende de ningún elemento y no obliga al navegador a recalcular estilo.
  root.style.setProperty('--mx', ((px / window.innerWidth) * 2 - 1).toFixed(3))
  root.style.setProperty('--my', ((py / window.innerHeight) * 2 - 1).toFixed(3))
}
